<template>
  <div class="dispatch-page" ref="pageRoot">
    <div class="pool-card pool-card-fill">
      <div class="pool-header" ref="poolHeader">
        <div class="pool-title-row">
          <h2 class="pool-title">家属端用户</h2>
        </div>
        <div class="pool-actions">
          <a-input
            v-model="query.keyword"
            allow-clear
            class="query-input"
            placeholder="搜索手机号/昵称"
            @pressEnter="onSearch"
          />
          <a-select
            v-model="query.state"
            allow-clear
            class="query-select"
            placeholder="账号状态"
            @change="onSearch"
          >
            <a-select-option :value="0">正常</a-select-option>
            <a-select-option :value="1">禁用</a-select-option>
          </a-select>
          <a-button type="primary" icon="search" @click="onSearch">查询</a-button>
        </div>
      </div>

      <div class="table-host" ref="tableHost" :style="tableHostStyle">
        <div class="table-body-wrap" :style="tableBodyStyle">
          <a-table
            rowKey="id"
            class="sticky-table"
            :columns="columns"
            :dataSource="list"
            :loading="loading"
            :pagination="false"
            :scroll="{ x: 900, y: tableScrollY }"
          >
            <template slot="state" slot-scope="text">
              <a-tag :color="Number(text) === 0 ? 'green' : 'red'">
                {{ Number(text) === 0 ? "正常" : "禁用" }}
              </a-tag>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-popconfirm
                :title="record.state === 0 ? '确定禁用该用户吗？' : '确定启用该用户吗？'"
                @confirm="toggleState(record)"
              >
                <a>{{ record.state === 0 ? "禁用" : "启用" }}</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
        <div class="table-pagination">
          <a-pagination
            :current="query.current"
            :pageSize="query.size"
            :total="total"
            show-size-changer
            :pageSizeOptions="['10', '20', '50']"
            :showTotal="(t) => `共 ${t} 条`"
            @change="onPageChange"
            @showSizeChange="onSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dispatchApi } from "./dispatchApi";
import { calcStickyTableLayout } from "./tableLayout";

export default {
  name: "DispatchFamilyUsers",
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      tableScrollY: 400,
      tableHostStyle: {},
      tableBodyStyle: {},
      query: {
        keyword: "",
        state: undefined,
        current: 1,
        size: 10,
      },
      columns: [
        { title: "ID", dataIndex: "id", width: 80 },
        { title: "昵称", dataIndex: "nickname", ellipsis: true },
        { title: "手机号", dataIndex: "mobileMasked", width: 140 },
        { title: "状态", dataIndex: "state", width: 90, scopedSlots: { customRender: "state" } },
        { title: "注册时间", dataIndex: "createTime", width: 170 },
        { title: "最后登录", dataIndex: "lastLoginTime", width: 170 },
        { title: "操作", key: "action", width: 90, fixed: "right", scopedSlots: { customRender: "action" } },
      ],
    };
  },
  mounted() {
    this.loadList();
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.$nextTick(() => {
      if (typeof ResizeObserver !== "undefined" && this.$refs.tableHost) {
        this.resizeObserver = new ResizeObserver(() => this.updateTableHeight());
        this.resizeObserver.observe(this.$refs.tableHost);
      }
      if (this.$refs.pageRoot) {
        this.resizeObserverPage = new ResizeObserver(() => this.updateTableHeight());
        this.resizeObserverPage.observe(this.$refs.pageRoot);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableHeight);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.resizeObserverPage) this.resizeObserverPage.disconnect();
  },
  methods: {
    async loadList() {
      this.loading = true;
      try {
        const data = await dispatchApi.pageFamilyUsers(this.query);
        this.list = data.records || [];
        this.total = data.total || 0;
      } catch (e) {
        this.$message.error((e && e.message) || "加载失败");
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
        this.$nextTick(this.updateTableHeight);
      }
    },
    onSearch() {
      this.query.current = 1;
      this.loadList();
    },
    onPageChange(page, size) {
      this.query.current = page;
      this.query.size = size;
      this.loadList();
    },
    onSizeChange(current, size) {
      this.query.current = 1;
      this.query.size = size;
      this.loadList();
    },
    async toggleState(record) {
      try {
        const next = record.state === 0 ? 1 : 0;
        await dispatchApi.updateFamilyUserState(record.id, next);
        this.$message.success(next === 0 ? "已启用" : "已禁用");
        this.loadList();
      } catch (e) {
        this.$message.error((e && e.message) || "操作失败");
      }
    },
    updateTableHeight() {
      this.$nextTick(() => {
        const host = this.$refs.tableHost;
        if (!host) return;
        const { scrollY, hostHeight } = calcStickyTableLayout(host, {
          theadH: 55,
          paginationH: 56,
          bottomGap: 20,
          minScrollY: 260,
          minHostH: 320,
        });
        this.tableScrollY = scrollY;
        this.tableHostStyle = { height: `${hostHeight}px` };
        this.tableBodyStyle = { "--table-scroll-y": `${scrollY}px` };
      });
    },
  },
};
</script>

<style scoped>
.dispatch-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  box-sizing: border-box;
  overflow: hidden;
}

.pool-card {
  background: #fff;
  border-radius: 0.75rem;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.pool-card-fill {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.pool-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
  gap: 1rem;
  flex-wrap: wrap;
}

.pool-title-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.pool-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.pool-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.query-input {
  width: 240px;
}

.query-select {
  width: 130px;
}

.table-host {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 0.75rem 0.75rem;
  overflow: hidden;
}

.table-body-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.table-pagination {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 0.75rem;
  margin-top: 0.25rem;
  border-top: 1px solid #f1f5f9;
}

.sticky-table {
  height: 100%;
}

.sticky-table >>> .ant-spin-nested-loading,
.sticky-table >>> .ant-spin-container,
.sticky-table >>> .ant-table,
.sticky-table >>> .ant-table-content,
.sticky-table >>> .ant-table-scroll {
  height: 100%;
}

.sticky-table >>> .ant-table-body {
  max-height: var(--table-scroll-y, 400px) !important;
}
</style>
